const menu = {
  key: "paymentSchedules",
  route: "/legacy/payment-schedules",
  label: "sidebar.paymentSchedules",
  icon: "faTable",
  group: "configuration",
  order: 80,
  permission: "legacy.paymentSchedules.read"
};

export default menu;